import { FOLDERS } from '@rp/contracts'
import { useRouterState } from '@tanstack/react-router'
import { z } from 'zod'

export const QueueSearch = z.object({
  folder: z.enum(FOLDERS).default('inbox').catch('inbox'),
  intent: z.string().optional().catch(undefined),
  kind: z.enum(['comment_thread', 'dm']).optional().catch(undefined),
  source: z.enum(['rule', 'llm', 'human']).optional().catch(undefined),
  author: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().default(1).catch(1),
})
export type QueueSearch = z.infer<typeof QueueSearch>

export const useQueueSearch = (): QueueSearch =>
  QueueSearch.parse(useRouterState({ select: (state) => state.location.search }))
